import ls from 'localstorage-slim'
import { useEffect } from 'react'
import { useNavigate } from 'react-router'

import { AccountPreferenceKeys, OnboardingStatus, Theme } from '@ankor-io/common/types/account'
import { updateThemeMode } from '@ankor-io/common/util/updateThemeMode'

import { ConnectedAccountProvider } from '@/providers/connectedAccount'
import { useUserContext } from '@/providers/user/useUserContext'
import Loading from '@/ui-components/Loading'
import LeftSideFeatures from '@/views/Onboarding/LeftSideFeatures'
import RightSideSetup from '@/views/Onboarding/RightSideSetup'

export const Onboarding = () => {
  const { preferences, isLoading } = useUserContext()
  const navigate = useNavigate()

  useEffect(() => {
    if (preferences?.[AccountPreferenceKeys.ONBOARDING_STATUS]) {
      // If status is complete or skipped, redirect to home
      if (
        preferences[AccountPreferenceKeys.ONBOARDING_STATUS] === OnboardingStatus.COMPLETED ||
        preferences[AccountPreferenceKeys.ONBOARDING_STATUS] === OnboardingStatus.SKIPPED
      ) {
        navigate('/')
      }
    }
  }, [preferences, navigate])

  // Outside of the App wrapper, set the theme mode to the user's browser preference
  useEffect(() => {
    // Read from browser setting of dark theme and move to session storage.
    const storageValue: Theme | null = ls.get('prefers-color-scheme')
    if (storageValue) {
      // use previously set pref.
      updateThemeMode(storageValue)
    } else {
      // read from the browser.
      if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
        updateThemeMode(Theme.DARK)
      } else {
        updateThemeMode(Theme.LIGHT)
      }
    }
  }, [])

  // Don't show the onboarding content until we determine the user's onboarding status
  if (isLoading) {
    return <Loading />
  }

  return (
    <div className="min-h-screen flex flex-col lg:flex-row">
      <LeftSideFeatures />
      <ConnectedAccountProvider>
        <RightSideSetup />
      </ConnectedAccountProvider>
    </div>
  )
}

export default Onboarding
